/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createHook,
	type Action,
	type BoundActions,
	type HookFunction,
} from '@atlassian/react-sweet-state';
import { layoutStore } from '../../store/index.tsx';
import type {
	LayoutState,
	BannerState,
	LeftSidebarState,
	RightSidebarState,
	BottomRightPortalState,
	PreviewPanelState,
} from '../../../../common/types.tsx';

export const useIsChromeless: HookFunction<
	boolean,
	BoundActions<
		LayoutState,
		{
			readonly setIsChromeless: (isChromeless: boolean) => Action<LayoutState>;
			readonly setIsFullscreen: (isFullscreen: boolean) => Action<LayoutState>;
			readonly showBanner: (newState: BannerState) => Action<LayoutState>;
			readonly dismissCurrentBanner: () => Action<LayoutState>;
			readonly setLeftSidebarState: (newState: Partial<LeftSidebarState>) => Action<LayoutState>;
			readonly setRightSidebarState: (newState: RightSidebarState) => Action<LayoutState>;
			readonly openRightSidebar: (
				panelId: string,
				width: number,
				isMinimised?: boolean,
				toTop?: boolean,
			) => Action<LayoutState>;
			readonly closeRightSidebar: (panelId: string) => Action<LayoutState>;
			readonly closeAllRightSidebar: () => Action<LayoutState>;
			readonly closeCurrentRightSidebar: () => Action<LayoutState>;
			readonly minimiseRightSidebar: (panelId: string) => Action<LayoutState>;
			readonly registerBottomRightCornerContainer: (
				ref: HTMLElement | null | undefined,
			) => Action<LayoutState>;
			readonly insertBottomRightCornerPortal: (
				item: BottomRightPortalState,
			) => Action<LayoutState, void, number>;
			readonly removeBottomRightCornerPortal: (id: string) => Action<LayoutState>;
			readonly setPreviewPanelState: (newState: Partial<PreviewPanelState>) => Action<LayoutState>;
		}
	>,
	void
> = createHook(layoutStore, {
	selector: (state) => state.isChromeless,
});
